export const ALL_SETTLEMENT_METHODS = [
  { id: 'AUCTION', displayValue: 'Auction' },
  { id: 'CASH', displayValue: 'Cash' },
  { id: 'PHYSICAL', displayValue: 'Physical' },
  { id: 'FIXED_RECOVERY', displayValue: 'Fixed Recovery' },
  { id: 'ZERO_RECOVERY', displayValue: 'Zero Recovery' },
];

export const RECOVERY_SETTLEMENT_METHODS = [
  {
    id: 'FIXED_RECOVERY',
    displayValue: 'Fixed Recovery',
  },
  {
    id: 'ZERO_RECOVERY',
    displayValue: 'Zero Recovery',
  },
];
